(function($, root) {
  "use strict";

  $.playAudio = function() {

    if (window.rdo.audioPlayer) {
      if (!window.rdo.audioPlayer.playing) {
        window.rdo.audioPlayer.play();
      }
    }

  }

  $.pauseAudio = function() {

    if (window.rdo.audioPlayer) {
      if (window.rdo.audioPlayer.playing) {
        window.rdo.audioPlayer.pause();
      }
    }

  }

})(jQuery, this);
